import React, { ReactNode, useRef } from "react";
import Backdrop from "../backdrop";
import styles from "./glassy-modal.module.scss";
import { GradientBorderContainer } from "@src/components/templates/layouts/gradient-border-container/gradient-border-container";
import { useClickOutsideListener } from "@src/hooks/use-click-outside-listener";

interface GlassyModalPropTypes {
  children: ReactNode;
  onClickOutside?: () => void;
}

const cssClassName = "glassy-modal";

export const GlassyModal = ({
  children,
  onClickOutside,
}: GlassyModalPropTypes) => {
  // Ref for detecting outside clicks on modal content
  const ref = useRef<HTMLDivElement | null>(null);

  // Enable outside-click handling only when onClickOutside is provided
  useClickOutsideListener(
    ref,
    () => onClickOutside?.() ?? (() => ({})),
    Boolean(onClickOutside),
  );

  return (
    <div className={styles[cssClassName]}>
      <Backdrop />
      <div className={styles[`${cssClassName}__center-container`]}>
        <div className={styles[`${cssClassName}__drop-shadow`]}>
          <GradientBorderContainer radius={8}>
            <div ref={ref} className={styles[`${cssClassName}__inner-wrapper`]}>
              {children}
            </div>
          </GradientBorderContainer>
        </div>
      </div>
    </div>
  );
};
